import React from 'react';

import Image from '@atlaskit/image';
import { Box, Stack, Text, xcss } from '@atlaskit/primitives';
import Anchor from '@atlaskit/primitives/anchor';

const containerStyles = xcss({
	backgroundColor: 'elevation.surface.raised',
	border: '1px solid',
	borderColor: 'color.border',
	borderRadius: 'border.radius.200',
	height: '100%',
	overflow: 'hidden',
	padding: 'space.200',
	textDecoration: 'none',
	textOverflow: 'ellipsis',
	transition: '0.25s',
	width: '180px',
	whiteSpace: 'normal',

	':hover': {
		backgroundColor: 'elevation.surface.raised.hovered',
		textDecoration: 'none',
	},
});

const avatarStyles = xcss({
	borderRadius: '50%',
	height: '80px',
	overflow: 'hidden',
	width: '80px',
});

interface Props {
	name: string;
	jobTitle: string;
	profilePicUrl: string;
	profileUrl: string;
	onClick: () => void;
}

export const CompactPersonCard = ({
	name,
	onClick,
	profilePicUrl,
	jobTitle,
	profileUrl,
}: Props) => {
	return (
		<Anchor href={profileUrl} xcss={containerStyles} onClick={onClick}>
			<Stack alignInline="center" space="space.150">
				<Box xcss={avatarStyles}>
					<Image src={profilePicUrl} />
				</Box>
				<Stack alignInline="center" space="space.050">
					<Text maxLines={1} weight="semibold">
						{name}
					</Text>
					<Text color="color.text.subtlest" maxLines={1}>
						{jobTitle}
					</Text>
				</Stack>
			</Stack>
		</Anchor>
	);
};
